import { assignmentRoutes } from "./AssignmentRoutes";
import { studentRoutes } from "./StudentRoutes";
import { contentRoutes } from "./ContentRoutes";
import { lessonPlannerRoutes } from "./LessonPlannerRoutes";
import { authRoutes } from "./AuthRoutes";
import { profileRoutes } from "./ProfileRoutes";
import { assistantRoutes } from "./AssistantRoutes";
import { dashboardRoutes } from "./DashboardRoutes";
import { toolRoutes } from "./ToolRoutes";
import { mediaRoutes } from "./MediaRoutes";

export const allRoutes = [
  ...authRoutes,
  ...profileRoutes,
  ...assistantRoutes,
  ...dashboardRoutes,
  ...toolRoutes,
  ...mediaRoutes,
  ...assignmentRoutes,
  ...studentRoutes,
  ...contentRoutes,
  ...lessonPlannerRoutes,
];
